import { render, staticRenderFns } from "./DetalleLiquidacionTable.vue?vue&type=template&id=b5c9f90a"
import script from "./DetalleLiquidacionTable.vue?vue&type=script&lang=js"
export * from "./DetalleLiquidacionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports